<script setup lang="ts">
  import { MpText } from '@borg/ui';

  defineProps<{
    label: string;
    value?: string;
  }>();

  const slots = useSlots();

  const isDefaultSlotNotEmpty = computed(() => {
    return slots.default && slots.default()[0].children?.length;
  });
</script>

<template>
  <div
    v-if="value || isDefaultSlotNotEmpty"
    class="row"
  >
    <MpText
      no-margin
      bold
    >
      {{ label }}
    </MpText>
    <MpText
      v-if="value"
      no-margin
    >
      {{ value }}
    </MpText>
    <span v-else>
      <slot />
    </span>
  </div>
</template>

<style scoped lang="scss">
  .row {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: var(--mp-space-30);
  }
</style>
